import React from "react"

import { Box } from "@mui/material"

import {
	ErrorResponse,
	Loading,
	RestResponse,
} from "@sinossi/mates-react-library"

import {
	AssignableUsers,
	PaginatedResponse,
	SearchFilter,
	Template,
	WorkflowTemplateSteps,
} from "models"
import withUseRouter, { UseRouterParams } from "services/router"
import { WorkflowService } from "services/workflow.service"
import {
	PageHeader,
	RoutesData,
} from "components/commons"
import WorkflowComponent from "components/workflow/workflow-component"
import {
	MatesComponent,
	MatesComponentState,
} from "components/mates-component"

interface WorkflowProps extends UseRouterParams {
}
interface WorkflowState extends MatesComponentState {
	loading: boolean
	workflowListResponse: PaginatedResponse<Workflow> | null
	workflowListRequest: SearchFilter
	workflowTemplatesListResponse: PaginatedResponse<Template> | null
	workflowTemplatesListRequest: SearchFilter
	templateStepsResponse: WorkflowTemplateSteps | null
	activeSection: string
	selectedTemplateId: string
	assignableUsers: AssignableUsers[] | null

}
class Workflow extends React.Component<WorkflowProps, WorkflowState> {
	private readonly matesComponent: MatesComponent<WorkflowProps, WorkflowState> = new MatesComponent(this)

	constructor(props: WorkflowProps) {
		super(props)
		this.state = {
			...this.matesComponent.setupState(),
			loading: true,
			workflowTemplatesListResponse: null,
			workflowTemplatesListRequest: SearchFilter.empty(),
			workflowListResponse: null,
			workflowListRequest: SearchFilter.empty(),
			activeSection: "Workflow",
			templateStepsResponse: null,
			selectedTemplateId: "",
			assignableUsers: null

		}
	}

	componentDidMount() {
		WorkflowService.getWorkflows(
			this.state.workflowListRequest,
			this.workflowsCallback,
			this.matesComponent.onException,
		)
	}

	private onSectionChanged = (section: string) => {
		if (section === "Workflow") {
			this.setState(() => ({
				activeSection: section,
				loading: true,
			}), () => (this.getWorkflowsList(this.state.workflowListRequest)))
		}
		if (section === "Template") {
			this.setState(() => ({
				activeSection: section,
				loading: true,
			}), () => (this.getWorkflowTemplateList(this.state.workflowTemplatesListRequest)))
		}
	}

	private getWorkflowsList = (request: SearchFilter) => {
		this.setState(() => ({
			loading: true,
		}), () => WorkflowService.getWorkflows(request, this.workflowsCallback, this.matesComponent.onException))
	}

	private workflowsCallback = (response: RestResponse<PaginatedResponse<Workflow>, ErrorResponse>) => {
		if (response.hasError()) {
			this.matesComponent.onError(response)
			return
		}

		this.setState(() => ({
			workflowListResponse: response.data,
		}), this.getAssignableUsers)
	}

	private getWorkflowTemplateList = (request: SearchFilter) => {
		this.setState(
			() => ({
				loading: true,
			}),
			() => WorkflowService.getWorkflowTemplatesList(request,
				this.workflowTemplateListCallback,
				this.matesComponent.onException,
			),
		)
	}

	private workflowTemplateListCallback = (response: RestResponse<PaginatedResponse<Template>, ErrorResponse>) => {
		if (response.hasError()) {
			this.matesComponent.onError(response)
			return
		}

		if (response.data) {
			this.setState(() => ({
				workflowTemplatesListResponse: response.data,
			}), this.getAssignableUsers)
		}
	}

	private getAssignableUsers = () => {
		WorkflowService.getAssignableUsers("-1", this.getAssignableUsersCallback, this.matesComponent.onException)
	}

	private getAssignableUsersCallback = (response: RestResponse<AssignableUsers[], ErrorResponse>) => {
		if (response.hasError()) {
			this.matesComponent.onError(response)
			return
		}

		this.setState(() => ({
			assignableUsers: response.data,
			loading: false
		}))
	}

	render() {
		return (
			<Box sx={{ pt: 2 }}>
				<Loading show={this.state.loading} />
				<PageHeader
					title={RoutesData.WORKFLOW.title}
					paths={[RoutesData.DASHBOARD, RoutesData.WORKFLOW,]} />

				{!this.state.loading &&
					<WorkflowComponent
						onSectionChanged={this.onSectionChanged}
						templatesData={this.state.workflowTemplatesListResponse}
						workflowsData={this.state.workflowListResponse}
						usersData={this.state.assignableUsers}
						templateStepsData={this.state.templateStepsResponse}
						activeSection={this.state.activeSection}
						handleTemplatePagination={this.getWorkflowTemplateList}
						handleWorkflowPagination={this.getWorkflowsList}
					/>
				}
			</Box>
		)
	}
}

export default withUseRouter(Workflow)
